module.exports = __webpack_public_path__ + "img/instagram.9811d14e.svg";